import React from "react";
import styled from "styled-components";

import YoutubeIcon from '../../../Image/YoutubeIcon.png';

export default function URLInput(props) {
  const { value, setValue, placeholder, isEdit } = props;

	function handleChange(e) {
    setValue(e.target.value);
	}

	function handleFocus(e) {
	}

	function handleBlur(e) {
	}

  return (
    <InputView>
      <Image src={YoutubeIcon}/>
      <Input
        placeholder={placeholder}
        value={value}
        type='text'
        disabled={!isEdit}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur} />
    </InputView>
  )
}

const InputView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0px 10px 2px 10px;

  width: calc(100% - 22px);

  gap: 8px;

  border: 1px solid #D92828;
  border-radius: 10px;
  background-color: #2F2F32;
`;

const Image = styled.img`
  width: 30px;
  height: 30px;
`;

const Input = styled.input`
	font-family: Poppins-Medium;
	font-size: 14px;
	line-height: 17px;

	width: calc(100% - 38px);
	height: 17px;

	padding: 0 0 0 0;
	margin: 0 0 0 0;

	outline: none;
	
	color: #FFFFFF;

  border: none;
  background-color: #2F2F32;

	::placeholder {
		color: #6A6A6C;
	}
  
  transition: all 0.3s ease-in-out;
`;